import React from "react";

const MISSION_TITLE_TEXT =
  "Being Human Matters eases oncology patients’ copays and coinsurance costs, ensuring survival depends on care not finances.";
const MISSION_BODY_TEXT =
  "We partner with Penn Medicine Princeton Medical Center’s Oncology Social Work and Financial Navigator team and Merwick Care and Rehabilitation to help patients with expenses and provide relief on their bills, because survival should never depend on finances.";

export default function Mission() {
  const styles = {
    section: {
      background: `linear-gradient(180deg, var(--mission-top) 0%, var(--mission-mid) 55%, var(--mission-bottom) 100%)`,
      padding: "clamp(16px, 2.2vw, 28px) clamp(12px, 2vw, 28px)",
      marginTop: 0,
    },
    container: {
      maxWidth: "min(1600px, 94vw)",
      margin: "0 auto",
      textAlign: "center",
    },
    title: {
      fontWeight: 600,
      fontSize: "clamp(22px, 2.2vw, 34px)",
      lineHeight: 1.25,
      margin: "0 0 10px 0",
      color: "var(--text-heading)",   // navy
      letterSpacing: "0.2px",
    },
    text: {
      fontWeight: 700,
      fontSize: "clamp(16px, 1.25vw, 20px)",
      lineHeight: 1.6,
      margin: 0,
      color: "var(--text-heading)",   // navy for strong contrast
      maxWidth: "min(1200px, 96%)",
      marginInline: "auto",
    },
    wrap: { display: "grid", gap: 12 },
  };

  return (
    <section id="Mission" style={styles.section} aria-label="Our Mission">
      <div style={styles.container}>
        <div style={styles.wrap}>
          <h1 style={styles.title}>{MISSION_TITLE_TEXT}</h1>
          <p style={styles.text}>{MISSION_BODY_TEXT}</p>
        </div>
      </div>
    </section>
  );
}
